module.exports = __webpack_public_path__ + "static/media/pdf_icon.3026ea74.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/pdf_icon.png
// module id = 1910
// module chunks = 0